// @ts-nocheck
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

const getQuantityTooltipStyles = (
    sizeVariant: TextFieldPresentationProps["sizeVariant"] = "default",
    isProductCard?: boolean,
): TooltipPresentationProps => {
    const offsetBottom = pxToRem(sizeVariant === "small" ? -5 : -10);
    const offsetLeft = pxToRem(sizeVariant === "small" ? 21 : 25);

    return {
        cssOverrides: {
            tooltipWrapper: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipWrapper}
                position: absolute;
                bottom: ${offsetBottom};
                left: ${isProductCard ? pxToRem(-5) : offsetLeft};
            `,
            tooltipClickable: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipClickable}
                display: none;
            `,
            tooltipContainer: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipContainer}
                ${() => {
                    if (isProductCard) {
                        return css`
                            width: ${pxToRem(200)};
                            left: 0;
                            transform: none;
                        `;
                    }
                }}
            `,
            tooltipArrow: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipArrow}
                ${() => {
                    if (isProductCard) {
                        return css`
                            left: ${pxToRem(20)};
                            transform: none;
                        `;
                    }
                }}
            `,
            tooltipBody: css`
                ${x => x.theme.tooltip.defaultProps?.cssOverrides?.tooltipBody}
                ${() => {
                    if (isProductCard) {
                        return css`
                            text-align: left;
                        `;
                    }
                }}
            `,
        },
    };
};

export default getQuantityTooltipStyles;
